interface GetButtonProps {
  label?: string;
  size?: "md" | "sm";
  variant?: "soft" | "primary";
  onClick?: () => void;
}

const sizes = {
  md: "min-w-[72px] px-5 py-1.5 text-[15px]",
  sm: "min-w-[60px] px-4 py-1 text-[13px]",
};

const variants = {
  soft: "bg-[#F2F2F7] text-[#007AFF] active:bg-[#E5E5EA]",
  primary: "bg-[#007AFF] text-white active:bg-[#0062CC]",
};

export function GetButton({ label = "Get", size = "md", variant = "soft", onClick }: GetButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`shrink-0 rounded-full font-bold uppercase transition active:scale-95 ${sizes[size]} ${variants[variant]}`}
    >
      {label}
    </button>
  );
}